@let showNavigation = this.showNavigation();
@let cfg = drawerService.config();
@let drawerOpen = drawerService.isOpen();
<div class="app-screen">
  @if (showNavigation) {
    <app-sidebar />
  }
  <div class="app-screen--content">
    <div class="router-container">
      <router-outlet />
    </div>
  </div>
  <app-toast-container>
    @for (toast of toasts; track $index) {
      <app-toast [message]="toast.message"
        [type]="toast.type"
       />
    }
  </app-toast-container>
</div>

<!-- Global right-side drawer: plain CSS over the screen, no Material (task-modernize-internal-apps §1.1 row 5).
     The backdrop click and ESC close it the way the mat-drawer did; the form-drawer service is a separate
     thing and runs on the CDK dialog. -->
@if (drawerOpen) {
  <div class="app-drawer-backdrop" (click)="onDrawerClose()" aria-hidden="true"></div>
}
<aside class="app-drawer" [class.app-drawer--open]="drawerOpen" role="dialog" aria-modal="true" [attr.aria-hidden]="!drawerOpen" [attr.inert]="drawerOpen ? null : ''">
  @if (cfg) {
    <div class="drawer-content">
      <div class="drawer-header">
        <h3>{{ cfg.title }}</h3>
        <button type="button" class="icon-btn" (click)="closeDrawer()" aria-label="Close">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="drawer-body">
        <!-- Add Subscription Item -->
        @if (cfg.type === 'add-subscription-item') {
          <app-add-subscription-item [inputData]="cfg.data"
            (itemAdded)="onItemAdded($event)"
            (cancelled)="closeDrawer()"
           />
        }
        <!-- Invoice Detail -->
        @if (cfg.type === 'invoice-detail') {
          <app-invoice-detail [inputData]="cfg.data"
            (actionPerformed)="onInvoiceAction($event)"
            (closed)="closeDrawer()"
           />
        }
        <!-- Custom template (e.g. client contact detail) -->
        @if (cfg.type === 'custom' && cfg.template) {
          <ng-container *ngTemplateOutlet="cfg.template" />
        }
      </div>
    </div>
  }
</aside>
